module.exports = __webpack_public_path__ + "static/about_authors_art-7867b7fbb36071b70ec5be5f065529b2.png";